/* eslint-disable react/display-name */
// react
import React, { useEffect, useState, useRef } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import dayjs from 'dayjs'

import Events from '@st-operations/uikit/Events.js'

// components
import ListView from '_components/list-view/index.jsx'
import Header from '_components/header/index.jsx'

import { getLogsEnum } from '_services/logs'

// Styles
import './styles.scss'

const MediaMeasurementCampaignsLogs = () => {
  const [createdByOptions, setCreatedByOptions] = useState([])
  const [orgOptions, setOrgOptions] = useState([])
  const [actionOptions, setActionOptions] = useState([])

  const listViewItemsRef = useRef([])

  useEffect(() => {
    getLogsEnum('created_by.email').then(setCreatedByOptions)
    getLogsEnum('created_by.org').then(setOrgOptions)
    getLogsEnum('data.action').then(setActionOptions)
  }, [])

  const handleSelectionChange = ({ action, items }) => {
    const selectedEntities = listViewItemsRef.current.filter(({ _id }) => items.includes(_id))
    Events.emit('ListView-selection', { action, items, entities: selectedEntities })
  }

  return (
    <div id="media-measurement-campaigns-page" className="media-measurement-campaigns">
      <Header title="Online Media Measurements – Logs"></Header>
      <div className="batch-sidebar__list-view-wrapper">
        <ListView
          itemsRef={listViewItemsRef}
          onSelectionChange={handleSelectionChange}
          columns={[
            // {
            //   name: 'id',
            //   key: '_id',
            //   styles: {
            //     maxWidth: '200px',
            //     textAlign: 'left',
            //   },
            // },
            {
              name: 'Audience Name',
              key: 'data.audience_name',
              render: (item) => (
                <Link to={`/online-media-measurements/${item.data.audience_id}`}>
                  {item.data.audience_name}
                </Link>
              ),
              styles: {
                maxWidth: '300px',
                textAlign: 'left',
              },
            },
            {
              name: 'Action',
              key: 'data.action',
              styles: {
                maxWidth: '200px',
                textAlign: 'left',
              },
            },
            {
              name: 'User',
              key: 'created_by.email',
              styles: {
                maxWidth: '200px',
                textAlign: 'left',
              },
            },
            window._isShareThisUser
              ? {
                  name: 'Organization',
                  key: 'created_by.org',
                  styles: {
                    maxWidth: '150px',
                    textAlign: 'left',
                  },
                }
              : null,
            {
              name: 'Created At',
              key: 'created_at',
              styles: {
                maxWidth: '150px',
                textAlign: 'left',
              },
              render: (item) => <span>{dayjs(item.created_at).format('MM/DD/YYYY HH:mm')}</span>,
              sortable: true,
            },
          ].filter(Boolean)}
          entities="logs"
          searchable={false}
          filters={[
            {
              name: 'data.action',
              label: 'Action',
              options: actionOptions,
              all: true,
              className: 'audiences__filters',
            },
            {
              name: 'created_by.email',
              label: 'User',
              options: createdByOptions,
              all: true,
              className: 'audiences__filters',
            },
            window._isShareThisUser
              ? {
                  name: 'created_by.org',
                  label: 'Organization',
                  options: orgOptions,
                  all: true,
                  className: 'audiences__filters',
                }
              : null,
          ].filter(Boolean)}
          sort_key={'updated_at'}
          sort_dir={-1}
        />
      </div>
    </div>
  )
}

// export
export default MediaMeasurementCampaignsLogs
